import { render, staticRenderFns } from "./CommonVsCompetitorTable.vue?vue&type=template&id=05f46ee4&scoped=true&"
import script from "./CommonVsCompetitorTable.vue?vue&type=script&lang=ts&"
export * from "./CommonVsCompetitorTable.vue?vue&type=script&lang=ts&"
import style0 from "./CommonVsCompetitorTable.vue?vue&type=style&index=0&id=05f46ee4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f46ee4",
  null
  
)

export default component.exports